import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=3e10b810&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=ts&"
export * from "./goodList.vue?vue&type=script&lang=ts&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=3e10b810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10b810",
  null
  
)

export default component.exports